import { Box, Divider, LinearProgress, Typography } from "@mui/material";

type Props = {
  coverage: number;
  totalInsightsNum: number;
  grantedPermissionsInsightsNum: number;
  permissionsNeededInsightsNum: number;
};

const Coverage: React.FC<Props> = ({
  coverage,
  totalInsightsNum,
  grantedPermissionsInsightsNum,
  permissionsNeededInsightsNum,
}) => (
  <Box sx={{ flex: 1, maxWidth: { xs: "100%", md: "208px" } }}>
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
      <Typography fontSize={14} fontWeight={500}>
        Coverage
      </Typography>
      <Typography fontSize={14} fontWeight={500}>
        {coverage}%
      </Typography>
    </Box>

    <Box sx={{ display: "flex", alignItems: "center" }}>
      <LinearProgress
        variant="determinate"
        value={coverage}
        data-testid="coverage-progress-bar"
        sx={{
          height: 11,
          mt: 0.5,
          borderRadius: 5,
          flexGrow: 1,
          backgroundColor: "#ebebeb",
          "& .MuiLinearProgress-bar": {
            backgroundColor: "warning.light",
            borderRadius: 5,
          },
        }}
      />
    </Box>
    <Box mt={3} gap={0.6} sx={{ display: "flex", flexDirection: "column" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography fontSize={12} variant="body2" color="text.secondary">
          Permissions granted:
        </Typography>
        <Typography fontSize={12} variant="body2">
          {grantedPermissionsInsightsNum} insights
        </Typography>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography fontSize={12} variant="body2" color="text.secondary">
          Permissions needed:
        </Typography>
        <Typography fontSize={12} variant="body2">
          {permissionsNeededInsightsNum} insights
        </Typography>
      </Box>
      <Divider />
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography fontSize={12} variant="body2" color="text.secondary">
          Total available:
        </Typography>
        <Typography fontSize={12} variant="body2">
          {totalInsightsNum} insights
        </Typography>
      </Box>
    </Box>
  </Box>
);

export default Coverage;
